module.exports = __webpack_public_path__ + "static/media/portret.b1c3db71.jpeg";